export enum AiPortals {}

export interface IPortalAISettings {
  isActive: boolean;
  supportedPortals: AiPortals[];
}
